<div class="forbidden-container">
  <h3>{{ "forbidden.error" | translate }}</h3>
</div>
